import "./create-mailing-list-modal.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

import {isDevQuan}     from "../../../debug/is-dev-quan";
import {ModalService3} from "../../../modal-service-3/modal-service-3";

import {SelectType}       from "./select-type/select-type";
import {mailingListTypes} from "./types/mailing-list-types";

export const CreateMailingListModal = (
    {
        itemId, onCreated, countryCode=undefined, eddmUnavailable=false,
        agentId=undefined, branchId=undefined,
        next: rootNext, isNDM=undefined
    }
) => cs(
    ["type", (_, next) => UseState({
        // ...isDevQuan() && {
        //     initValue: "radius",
        // },
        next,
    })],
    ({type}) => ModalService3({
        // initShow: isDevQuan(),
        width: 900,
        contentService: ({close, next}) => TypeSwitch({
            agentId,
            branchId,
            isNDM,
            next,
            onCreated,
            itemId, countryCode, eddmUnavailable, type, 
            onClose: () => {
                type.onChange(null);
                close();
            },
        }),
        rootNext,
        contentClassName: "create-mailing-list-modal-97e",
        xdQaName: "Create Mailing List",
    })
);


const TypeSwitch = ({onClose, itemId, branchId, isNDM, agentId, onCreated, countryCode, eddmUnavailable, type, next}) => cs(
    ({}) => (
        !type.value && !isNDM ? next({
            content: (
                SelectType({
                    onSelect: type.onChange,
                    branchId,
                    countryCode,
                    eddmUnavailable,
                })
            ),
        }) : (
            mailingListTypes.find((t) => (t.value === type.value) || (isNDM && t.value == "saturation")).service({
                entityId: agentId,
                onCancel: () => type.onChange(null),
                cancelLabel: !isNDM && "Back",
                // @ts-ignore
                itemId, countryCode,
                onClose,
                onCreated,
                next,
            })
        )
    ),
);

